// extracted by mini-css-extract-plugin
module.exports = {"card":"styles__card___x5YX2","button":"styles__button___bh1cq","icon":"styles__icon___2avcg","name":"styles__name___2J6AE","email":"styles__email___3Ldi2"};